import * as React from 'react';
import { CurrentPositionContext } from 'contexts/CurrentPositionContext';
import { useCurrentPosition } from 'hooks/useCurrentPosition';

export const CurrentPositionProvider = ({ children }: { children: React.ReactNode }) => {
  const { currentPosition, currentPositionRef, updatedAt, error, isLoaded } = useCurrentPosition();
  return (
    <CurrentPositionContext.Provider
      value={{ currentPosition, currentPositionRef, updatedAt, error, isLoaded }}
    >
      {children}
    </CurrentPositionContext.Provider>
  );
};
